import type { AvatarProps } from "@rally/ui-kit";

export const DRAWN_TONES = ["accent", "success", "neutral"] as const satisfies ReadonlyArray<
  NonNullable<AvatarProps["tone"]>
>;

export function drawnToneFor(handle: string): NonNullable<AvatarProps["tone"]> {
  let sum = 0;
  for (const at of handle.trim().toLowerCase()) sum += at.codePointAt(0) ?? 0;
  return DRAWN_TONES[sum % DRAWN_TONES.length] ?? "neutral";
}
